import { makeAutoObservable, runInAction } from "mobx";
import api from "../Utils/api";
import session from "../Utils/session";

class RecentUsersStore {
  currentUser = null;

  list = [];
  loaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  load() {
    const user = session.getTokenObject();
    this.currentUser = user;
    api.getRecentUsers().then((res) => {
      runInAction(() => {
        const list = res.users
          .map((u) => ({
            id: u.id,
            seenSince: u.seenSince,
            username: u.username,
            online: u.online,
            public: u.public,
            song: u.public
              ? `${u.song.title} - ${u.song.artist}`
              : `Private song`,
            image: u.song !== null ? u.song.thumbnail : null,
          }))
          .sort((u1, u2) => {
            if (u1.seenSince < u2.seenSince) return -1;
            if (u1.seenSince > u2.seenSince) return 1;
            return 0;
          });
        this.list = list;
        this.loaded = true;
      });
    });
  }
}

const recentUsersStore = new RecentUsersStore();
export default recentUsersStore;
